{
	"awaiting_provisioning": "In attesa",
	"columns": {
		"active_users": "Utenti attivi",
		"created_at": "Creata il",
		"name": "Nome",
		"status": "Stato",
		"usage": "Spazio usato"
	},
	"create": "Nuova organizzazione",
	"deactivate": {
		"action": "Disattiva",
		"confirm": "Disattiva l'organizzazione",
		"description": "I login vengono bloccati e tutte le sessioni aperte si chiudono, subito.",
		"intact": "Non viene cancellato niente: file, versioni, cronologia e registro di audit restano esattamente dove sono.",
		"pending": "Disattivazione…",
		"reversible": "L'operazione è reversibile: la riattivazione rimette l'organizzazione nello stato in cui era.",
		"success": "Organizzazione disattivata: login bloccati e sessioni chiuse.",
		"title": "Disattivare {{name}}?"
	},
	"destruction": {
		"action": "Distruggi i dati",
		"already_in_progress": "La distruzione era già in corso: questa richiesta l'ha ripresa dal punto in cui si era fermata.",
		"already_purged": "I dati di questa organizzazione erano già stati distrutti: non è cambiato nulla.",
		"audit_kept": "L'audit resta: il registro di quello che è stato fatto a questa organizzazione non fa parte di ciò che viene distrutto.",
		"available_description": "L'organizzazione è disattivata: da qui i suoi dati possono essere distrutti in modo definitivo, senza cestino, periodo di grazia o ripristino.",
		"confirm": "Distruggi definitivamente",
		"confirm_description": "Non si torna indietro: dopo, niente di quello che segue può essere recuperato.",
		"confirm_title": "Distruggere i dati di {{name}}?",
		"destroys": {
			"bin": "il contenuto del cestino",
			"files": "tutti i file dell'organizzazione",
			"intro": "Vengono distrutti:",
			"people": "le persone dell'organizzazione e i loro account",
			"realm": "il realm di accesso dell'organizzazione",
			"versions": "tutte le versioni precedenti di ogni file"
		},
		"done_description": "I dati di questa organizzazione sono stati distrutti: non può essere riattivata, ma il registro di audit resta.",
		"done_title": "Dati distrutti",
		"nodes": "File e cartelle rimossi",
		"object_versions": "Versioni rimosse",
		"pending": "Distruzione…",
		"progress_description": "Il lavoro procede in background e non può essere annullato. I conteggi crescono man mano che i dati vengono rimossi, senza un totale da cui ricavare una percentuale.",
		"progress_title": "Distruzione in corso",
		"queued": "Distruzione avviata. Non può essere annullata.",
		"resume": "Riprendi la distruzione",
		"resume_help": "Se i conteggi non si muovono da un po', la distruzione si è fermata: riprenderla continua dal punto in cui era arrivata.",
		"resuming": "Ripresa…",
		"started_at": "Ordinata il",
		"started_at_unknown": "Non registrata",
		"title": "Distruzione dei dati",
		"type_name_hint": "Deve corrispondere esattamente, maiuscole e spazi compresi.",
		"type_name_label": "Per confermare, digita il nome dell'organizzazione",
		"type_name_mismatch": "Il nome digitato non corrisponde."
	},
	"detail": {
		"attempts_label": "Tentativi di provisioning",
		"attempts_one": "{{count}} tentativo",
		"attempts_other": "{{count}} tentativi",
		"created_on": "creata il {{date}}",
		"identity": {
			"description": "Nome mostrato agli utenti e indirizzo usato per accedere.",
			"name": "Nome organizzazione",
			"slug": "Indirizzo di accesso",
			"title": "Identità"
		},
		"last_attempt_label": "Ultimo tentativo",
		"last_attempt_never": "Nessun tentativo finora",
		"loading": "Caricamento dell'organizzazione…",
		"more_actions": "Altre azioni",
		"not_found_description": "Questo indirizzo non corrisponde a nessuna organizzazione. Può essere stata distrutta, oppure il link non è più valido.",
		"not_found_title": "Organizzazione non trovata",
		"offline_description": "Il browser risulta offline: la richiesta riparte da sola appena la connessione torna.",
		"offline_title": "Connessione assente",
		"provisioning": "Provisioning",
		"quota": {
			"action": "Modifica quota",
			"assigned": "Assegnata alle persone",
			"back": "Indietro",
			"bar": "{{used}} in uso, {{reserved}} assegnati e non ancora usati, {{free}} da assegnare, su {{quota}}",
			"confirm": "Imposta la quota",
			"confirm_below_assigned": "Alle persone sono già assegnati {{assigned}}: gli amministratori potranno solo ridurre le assegnazioni.",
			"confirm_below_used": "L'organizzazione usa già {{used}}: finché non torna sotto la quota, ogni caricamento verrà rifiutato.",
			"confirm_title": "Impostare la quota a {{quota}}?",
			"description": "Gli amministratori la ripartiscono tra gli utenti.",
			"description_unlimited": "Gli amministratori possono comunque fissare una quota per ogni utente.",
			"dialog_description": "In uso ora: {{used}}. Assegnata alle persone: {{assigned}}.",
			"dialog_title": "Quota di {{name}}",
			"done": "La quota ora è {{quota}}.",
			"done_unlimited": "La quota ora non ha limite.",
			"free": "Da assegnare",
			"full": "Quota raggiunta: ogni caricamento viene rifiutato.",
			"in_use": "In uso ora",
			"limit": "Quota",
			"measured": "Rilevamento giornaliero, versioni incluse",
			"near": "Restano {{free}} prima di raggiungere la quota.",
			"no_limit": "Nessun limite",
			"over_assigned": "Le persone hanno più spazio assegnato della quota: gli amministratori possono solo ridurre le assegnazioni.",
			"pending": "Salvataggio…",
			"reserved": "Assegnato, non ancora usato",
			"save": "Salva",
			"title": "Spazio",
			"too_large": "Il massimo è {{max}}."
		},
		"sections": "Sezioni",
		"tab_overview": "Panoramica",
		"view_audit": "Vedi audit"
	},
	"empty": {
		"description": "Su questa istanza non c'è ancora nessun cliente. Creane uno per cominciare.",
		"no_matches_description": "Nessuna organizzazione corrisponde alla ricerca o ai filtri attivi.",
		"no_matches_title": "Nessun risultato",
		"title": "Nessuna organizzazione"
	},
	"failed_step": {
		"admin_invite": "L'invito al primo amministratore non è riuscito.",
		"identity": "La creazione del realm di identità non è riuscita.",
		"storage": "La creazione dello storage non è riuscita."
	},
	"failure": {
		"code": "Codice:",
		"no_detail": "Il sistema esterno non ha restituito né un codice né un messaggio.",
		"repeated_one": "Il provisioning si è già fermato {{count}} volta sullo stesso passo: finché la causa non cambia, riprovare non cambierà l'esito.",
		"repeated_other": "Il provisioning si è già fermato {{count}} volte sullo stesso passo: finché la causa non cambia, riprovare non cambierà l'esito.",
		"source": {
			"admin_invite": "Risposta del servizio di invito, testuale:",
			"identity": "Risposta di Keycloak, testuale:",
			"storage": "Risposta del servizio di storage, testuale:",
			"unknown": "Risposta del sistema esterno, testuale:"
		},
		"step_unknown": "La creazione si è fermata, ma il passo non è stato registrato."
	},
	"filters": {
		"status": "Stato"
	},
	"form": {
		"admin_email": "Email amministratore",
		"admin_email_invalid": "Inserisci un indirizzo email valido.",
		"admin_email_placeholder": "admin@cliente.com",
		"admin_email_required": "L'indirizzo email è obbligatorio.",
		"back": "Indietro",
		"cancel": "Annulla",
		"creating": "Creazione…",
		"language": "Lingua dell'invito",
		"name": "Nome",
		"name_placeholder": "Acme Industries",
		"name_required": "Il nome è obbligatorio.",
		"name_too_long": "Usa al massimo {{max}} caratteri.",
		"next": "Avanti",
		"quota": "Quota di archiviazione",
		"quota_help": "Lo spazio totale a disposizione dell'organizzazione.",
		"quota_required": "Serve una quota maggiore di zero.",
		"quota_too_large": "Il massimo è {{max}}.",
		"slug": "URL personalizzato",
		"slug_available": "Questo indirizzo è libero.",
		"slug_checking": "Controllo dell'indirizzo…",
		"slug_help": "Min {{min}}, max {{max}} caratteri. Solo lettere minuscole, cifre e trattini singoli",
		"slug_invalid": "Usa lettere minuscole, cifre e trattini singoli, da {{min}} a {{max}} caratteri.",
		"slug_permanent": "Questo indirizzo è permanente e non potrà essere cambiato.",
		"slug_placeholder": "acme-industries",
		"slug_required": "L'indirizzo è obbligatorio.",
		"slug_taken": "Questo indirizzo è già in uso.",
		"step": "Passo {{current}} di {{total}}",
		"submit": "Crea organizzazione",
		"title": "Nuova organizzazione"
	},
	"invitation": {
		"mail_down": {
			"drift": "I realm di questa istanza puntano a un relay di posta diverso dal nostro, quindi la posta di accesso delle sue organizzazioni non parte. Riapplica la configurazione di posta a tutti i realm. Poi rimanda gli inviti.",
			"title": "Gli inviti non escono dall'istanza",
			"unknown": "L'istanza segnala un problema di posta che questa schermata non riconosce: niente di ciò che è partito nel frattempo si può dare per arrivato. Controlla i log dell'istanza per la causa prima di reinviare.",
			"unreachable": "L'istanza non raggiunge il proprio relay di posta, quindi niente di ciò che è partito mentre era giù è arrivato. Fai rispondere il relay, poi rimandali."
		},
		"resend": {
			"already_active": "Non è stato inviato niente: questa persona ha già attivato il suo accesso.",
			"confirm": "Reinvia l'invito",
			"cooldown": "Reinvia tra {{seconds}} s",
			"description": "Arriverà una nuova email con un nuovo link di attivazione.",
			"not_queued": "Il messaggio non è stato messo in coda per l'invio: non è stato inviato niente e il codice precedente è ancora valido. Puoi riprovare subito.",
			"not_queued_database": "L'invito non è stato salvato: non è stato inviato niente e il codice precedente è ancora valido. Puoi riprovare subito.",
			"not_queued_identity": "Il servizio di accesso non ha risposto: non è stato inviato niente e il codice precedente è ancora valido. Puoi riprovare subito.",
			"pending": "Invio…",
			"sent": "Invito inviato di nuovo a {{email}}. Il relay ha accettato il messaggio: la consegna non è garantita.",
			"supersedes": "Se la persona ha già ricevuto la prima email, dovrà usare quella nuova.",
			"supersedes_title": "Il link precedente non funzionerà più",
			"throttled_one": "Si può inviare un messaggio al minuto per indirizzo. Riprova fra {{count}} secondo.",
			"throttled_other": "Si può inviare un messaggio al minuto per indirizzo. Riprova fra {{count}} secondi.",
			"throttled_soon": "Si può inviare un messaggio al minuto per indirizzo. Riprova fra poco.",
			"title": "Reinviare l'invito a {{email}}?"
		}
	},
	"owners": {
		"action": "Aggiungi proprietario",
		"cancel": "Annulla",
		"description": "Riceverà un invito con il link per accedere all'organizzazione.",
		"email": "Email",
		"language": "Lingua dell'invito",
		"promote": {
			"action": "Rendi proprietario",
			"conflict": "Non è stato possibile: nel frattempo la persona è stata disattivata o rimossa.",
			"done": "{{label}} ora è tra i proprietari.",
			"pending": "Salvataggio"
		},
		"refusal": {
			"address_taken": "Questo indirizzo appartiene già a una persona dell'organizzazione.",
			"already_invited": "Questo indirizzo ha già un invito in attesa.",
			"already_owner": "Questa persona è già tra i proprietari.",
			"deactivated": "Questa persona fa parte dell'organizzazione ma è disattivata. Potrà diventare proprietaria solo dopo che l'organizzazione l'avrà riattivata.",
			"member": "Questa persona fa già parte dell'organizzazione, quindi non serve un invito: puoi renderla proprietaria.",
			"rate_limited": "Hai scritto a questo indirizzo meno di un minuto fa. Riprova tra {{seconds}} secondi."
		},
		"remove": {
			"confirm": "Rimuovi",
			"description": "Perde subito l'accesso e viene disconnesso da tutti i dispositivi. Per farlo rientrare dovrai invitarlo di nuovo.",
			"done": "{{label}} non fa più parte dell'organizzazione.",
			"pending": "Rimozione",
			"title": "Rimuovere {{label}} dall'organizzazione?"
		},
		"revoke": {
			"confirm": "Rimuovi come proprietario",
			"description": "Non sarà più proprietario e resterà nell'organizzazione come amministratore.",
			"done": "{{label}} non è più proprietario.",
			"pending": "Salvataggio",
			"title": "Rimuovere {{label}} dai proprietari?"
		},
		"sending": "Invio in corso",
		"sent": "Invito inviato.",
		"submit": "Invia invito",
		"title": "Invita un proprietario"
	},
	"page_title": "Organizzazioni",
	"people": {
		"actions": {
			"only_owner": "Non puoi rimuovere l'ultimo proprietario",
			"open_menu": "Apri le azioni",
			"remove_owner": "Rimuovi dall'organizzazione",
			"resend": "Rimanda l'invito",
			"revoke_owner": "Rimuovi come proprietario"
		},
		"actions_column": "Azioni",
		"description": "A differenza degli altri amministratori, nessuno nell'organizzazione può rimuoverli, disattivarli o cambiarne il ruolo.",
		"email_column": "Email",
		"empty": "Ancora nessun proprietario.",
		"invitation_column": "Invito",
		"invitation_expired": "Scaduto il {{date}}",
		"invitation_expires": "Scade il {{date}}",
		"invitation_sent": "Inviato il {{date}}",
		"last_activity_column": "Ultimo accesso",
		"last_activity_never": "Mai",
		"name_column": "Nome",
		"no_value": "Nessun valore",
		"not_ready_description": "Un'organizzazione ha proprietari quando è attiva. La scheda Panoramica dice a che punto è arrivata la creazione, o se i dati sono stati distrutti.",
		"not_ready_title": "Ancora nessun proprietario",
		"owner": "Proprietario",
		"role": {
			"member": "Membro",
			"org_admin": "Amministratore"
		},
		"role_column": "Ruolo",
		"status": {
			"active": "Attivo",
			"deactivated": "Disattivato",
			"invited": "Invitato",
			"removed": "Rimosso"
		},
		"status_column": "Stato",
		"title": "Proprietari",
		"total_one": "{{count}} proprietario",
		"total_other": "{{count}} proprietari"
	},
	"reactivate": {
		"action": "Riattiva",
		"confirm": "Riattiva l'organizzazione",
		"description": "L'accesso riapre subito e l'organizzazione torna nello stato in cui era prima della disattivazione.",
		"pending": "Riattivazione…",
		"sessions": "Le sessioni chiuse dalla disattivazione non tornano: chi era collegato dovrà accedere di nuovo.",
		"success": "Organizzazione riattivata.",
		"title": "Riattivare {{name}}?"
	},
	"retry": {
		"action": "Riprova il provisioning",
		"admin_email": {
			"description": "Questa organizzazione si è fermata prima dell'invito, quindi l'indirizzo del primo amministratore non è stato salvato: indicalo di nuovo per far ripartire il provisioning.",
			"submit": "Riprova con questo indirizzo",
			"title": "Serve l'indirizzo del primo amministratore"
		},
		"already_in_progress": "Il provisioning è già in corso (qualcuno l'ha fatto ripartire poco fa, oppure non si era mai fermato): non c'è altro da fare che aspettare.",
		"pending": "Nuovo tentativo…",
		"queued": "Provisioning riavviato dal passo in cui si era fermato."
	},
	"search_placeholder": "Cerca per nome",
	"status": {
		"admin_invited": "In creazione",
		"failed": "Creazione non riuscita",
		"identity_ready": "In creazione",
		"pending": "In creazione",
		"purged": "Storage distrutto",
		"purging": "Distruzione dello storage",
		"ready": "Attiva",
		"storage_ready": "In creazione",
		"suspended": "Disattivata"
	},
	"step_state": {
		"active": "in corso",
		"done": "completato",
		"failed": "non riuscito",
		"pending": "non ancora eseguito"
	},
	"steps": {
		"admin_invite": "Invito amministratore",
		"identity": "Identità",
		"ready": "Attiva",
		"storage": "Storage"
	},
	"total_one": "{{count}} organizzazione",
	"total_other": "{{count}} organizzazioni",
	"usage": {
		"full": "piena",
		"measured_at": "Rilevato il {{date}}",
		"near": "quasi piena",
		"never_measured": "Nessun rilevamento riuscito",
		"of_quota": "{{used}} di {{quota}}",
		"stale": "Ultimo rilevamento non riuscito, valore del {{date}}",
		"unavailable": "Non disponibile"
	}
}
